export const CHANGE_LANGUAGE = "LOCALIZATION_CHANGE_LANGUAGE";
export const CHANGE_LANGUAGE_SUCCESS = "LOCALIZATION_CHANGE_LANGUAGE_SUCCESS";
export const CHANGE_LANGUAGE_ERROR = "LOCALIZATION_CHANGE_LANGUAGE_ERROR";

export const GET_LANGUAGE = "LOCALIZATION_GET_LANGUAGE";
export const GET_LANGUAGE_SUCCESS = "LOCALIZATION_GET_LANGUAGE_SUCCESS";
export const GET_LANGUAGE_ERROR = "LOCALIZATION_GET_LANGUAGE_ERROR";
